/**
 * RegistrarAtividadeDialog — registra um contato/atividade num SlideOverPanel.
 *
 * Antes o RegistrarAtividadeForm ficava inline sempre-visivel dentro da
 * Timeline. Agora vira acao deliberada ("Registrar contato" em Acoes
 * rapidas) que abre este dialog. Reusa o mesmo RegistrarAtividadeForm e o
 * mesmo callback de registrar atividade; fecha sozinho apos registrar com
 * sucesso (o form ja faz a validacao + reset internamente).
 */
import React from "react";

import SlideOverPanel from "../../../components/SlideOverPanel";

import RegistrarAtividadeForm from "./RegistrarAtividadeForm";

function RegistrarAtividadeDialog({ open, onClose, onRegistrar, subtitle }) {
  // Encadeia o callback do pai e fecha o dialog ao concluir. O form so chama
  // isto quando o registro foi bem-sucedido (validacao acontece la dentro).
  const registrar = async (dados) => {
    await onRegistrar(dados);
    onClose();
  };

  return (
    <SlideOverPanel
      open={open}
      onClose={onClose}
      title="Registrar contato"
      subtitle={subtitle}
      width="min(95vw, 480px)"
      footer={
        <button type="button" className="btn btn--secondary" onClick={onClose}>
          Fechar
        </button>
      }
    >
      <RegistrarAtividadeForm onRegistrar={registrar} />
    </SlideOverPanel>
  );
}

export default RegistrarAtividadeDialog;
